module.exports = __webpack_public_path__ + "img/solar.2883919c.jpg";